import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Slider from "react-slick";
import axios from "axios";

import { useLocation } from "react-router-dom";
import NavbarBuddhism from "../layout/NavbarBuddhism";
import Footer from "../layout/Footer";
import styles from "./buddhism.module.sass";

import buddhism01 from "../assets/images/buddhism/buddhism01.jpg";
import buddhism02 from "../assets/images/buddhism/buddhism02.jpg";
import buddhism03 from "../assets/images/buddhism/buddhism03.jpg";
import buddhism04 from "../assets/images/buddhism/buddhism04.jpg";
import buddhism05 from "../assets/images/buddhism/buddhism05.jpg";
import buddhism06 from "../assets/images/buddhism/buddhism06.jpg";
import schedule01 from "../assets/images/buddhism/schedule01.png";
import { NextArrow, PrevArrow } from "../components/sliderArrow";

function Buddhism() {
  const isMounted = useRef(false);
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();
  const [articleContent, setArticleContent] = useState();
  const [pictureList, setPictureList] = useState(null);

  let location = useLocation();
  const pageId = useMemo(() => new URLSearchParams(location.search).get("id"), [location.search]);

  const fetchPageData = useCallback(async (id) => {
    try {
      const response = await axios.post("/api/website/getPage", { id: id * 1 });

      setArticleContent(response.data.data.result.content);
      setPictureList([
        { id: 1, picturePath: buddhism01 },
        { id: 2, picturePath: buddhism02 },
        { id: 3, picturePath: buddhism03 },
        { id: 4, picturePath: buddhism04 },
        { id: 5, picturePath: buddhism05 },
        { id: 6, picturePath: buddhism06 },
        { id: 7, picturePath: buddhism06 },
        { id: 8, picturePath: buddhism06 },
        { id: 9, picturePath: buddhism06 },
      ]);
    } catch (error) {
      console.error("Error fetching article content:", error);
    }
  }, []);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      fetchPageData(pageId);
    }
  }, [fetchPageData, pageId, location.search]);

  if (pictureList === null) {
    return;
  }

  return (
    <>
      <NavbarBuddhism path={pageId} />
      <main>
        <section className="h-[250px] page-title flex justify-center items-center">
          <h2 className="text-[#3D3D3D] font-semibold text-5xl table:text-4xl mobile:text-3xl ">
            誠信佛堂
          </h2>
        </section>
        <section>
          <div className="max-w-[1600px] mx-auto table:mb-6 mobile:mb-6">
            <div className="px-10 pt-[75px] pb-10 flex flex-row gap-10 table:flex-col-reverse table:p-0 mobile:p-0 mobile:flex-col-reverse table:gap-8 mobile:gap-4">
              {pictureList.length > 0 && (
                <div className="w-[1000px] table:w-full mobile:w-full">
                  <div className="w-[86%] mx-auto table:w-full mobile:w-full">
                    <Slider
                      asNavFor={nav2}
                      ref={(slider) => setNav1(slider)}
                      dots={false}
                      fade={true}
                      swipeToSlide={true}
                      focusOnSelect={true}
                      slidesToShow={1}
                      slidesToScroll={1}
                      infinite={true}
                      prevArrow={<PrevArrow customClassName={styles.prevArrow} />}
                      nextArrow={<NextArrow customClassName={styles.nextArrow} />}
                    >
                      {pictureList.map((item) => {
                        return (
                          <div role="button" key={item.id} data-id={item.id} className="border">
                            <div className="aspect-[860/600] relative overflow-hidden">
                              <img
                                className="absolute top-0 left-0 w-full"
                                src={item.picturePath}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </Slider>
                  </div>
                </div>
              )}
              <div className="flex-1 text-2xl text-[#4B4A4A] flex flex-col gap-2 items-end table:w-full table:pt-10 table:px-10 table:text-xl mobile:text-base mobile:pt-4 mobile:px-4">
                <p dangerouslySetInnerHTML={{ __html: articleContent }} />
                <a href="#schedule" className="underline text-[#70C2E4]">
                  ▶ 查看課表
                </a>
              </div>
            </div>
          </div>
          {pictureList.length > 0 && (
            <div>
              <Slider
                asNavFor={nav1}
                ref={(slider) => setNav2(slider)}
                dots={false}
                slidesToShow={8}
                centerMode={pictureList.length > 8}
                infinite={pictureList.length > 8}
                swipeToSlide={true}
                focusOnSelect={true}
                slidesToScroll={1}
                prevArrow={null}
                nextArrow={null}
                responsive={[
                  {
                    breakpoint: 1350,
                    settings: {
                      slidesToShow: 6,
                      centerMode: pictureList.length > 6,
                      infinite: pictureList.length > 6,
                    },
                  },
                  {
                    breakpoint: 991,
                    settings: {
                      slidesToShow: 5,
                      centerMode: pictureList.length > 5,
                      infinite: pictureList.length > 5,
                    },
                  },
                  {
                    breakpoint: 766,
                    settings: {
                      slidesToShow: 4,
                      centerMode: pictureList.length > 4,
                      infinite: pictureList.length > 4,
                    },
                  },
                  {
                    breakpoint: 375,
                    settings: {
                      slidesToShow: 3,
                      centerMode: pictureList.length > 3,
                      infinite: pictureList.length > 3,
                    },
                  },
                ]}
              >
                {pictureList.map((item) => {
                  return (
                    <div role="button" key={item.id} data-id={item.id} className="border">
                      <div className="aspect-[860/600] relative overflow-hidden">
                        <img className="absolute top-0 left-0 w-full" src={item.picturePath} />
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </div>
          )}
        </section>
        <section>
          <div id="schedule" className="max-w-[1580px] mx-auto">
            <div className="pt-32 pb-48 px-10 table:pt-14 table:pb-14 mobile:pt-4 mobile:pb-4 mobile:px-4">
              <div className="aspect-[1500/1000] relative overflow-hidden">
                <img className="absolute top-0 left-0 w-full" src={schedule01} />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default Buddhism;
